const getFunctionUrl = ()  : string => {
    return process.env.REACT_APP_FUNCTION_URL!;
};


const EnvironmentService = {
    getFunctionUrl,
};

export default EnvironmentService;